module.exports = __webpack_public_path__ + "img/md-transgender.25a075f4.svg";